var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.JumpingTransition = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _animation = require("../../animation");
var _Easing = require("../../Easing");
var _animationBuilder = require("../animationBuilder");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return (0, _possibleConstructorReturn2.default)(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var _worklet_10364741825758_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,withTiming,config,withSequence,duration,Easing,callback}=this.__closure;const d=Math.max(Math.abs(values.targetOriginX-values.currentOriginX),Math.abs(values.targetOriginY-values.currentOriginY));return{initialValues:{originX:values.currentOriginX,originY:values.currentOriginY,width:values.currentWidth,height:values.currentHeight},animations:{originX:delayFunction(delay,withTiming(values.targetOriginX,config)),originY:delayFunction(delay,withSequence(withTiming(Math.min(values.targetOriginY,values.currentOriginY)-d,{duration:duration,easing:Easing.out(Easing.exp)}),withTiming(values.targetOriginY,{...config,duration:duration,easing:Easing.bounce}))),width:delayFunction(delay,withTiming(values.targetWidth,config)),height:delayFunction(delay,withTiming(values.targetHeight,config))},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultTransitions/JumpingTransition.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","withTiming","config","withSequence","duration","Easing","callback","__closure","d","Math","max","abs","targetOriginX","currentOriginX","targetOriginY","currentOriginY","initialValues","originX","originY","width","currentWidth","height","currentHeight","animations","min","easing","out","exp","bounce","targetWidth","targetHeight"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultTransitions/JumpingTransition.ts"],"mappings":"AAwBY,SAAAA,SAAMA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,UAAA,CAAAC,MAAA,CAAAC,YAAA,CAAAC,QAAA,CAAAC,MAAA,CAAAC,QAAA,OAAAC,SAAA,CAEjB,KAAM,CAAAC,CAAC,CAAGC,IAAI,CAACC,GAAG,CAChBD,IAAI,CAACE,GAAG,CAACb,MAAM,CAACc,aAAa,CAAGd,MAAM,CAACe,cAAc,CAAC,CACtDJ,IAAI,CAACE,GAAG,CAACb,MAAM,CAACgB,aAAa,CAAGhB,MAAM,CAACiB,cAAc,CACvD,CAAC,CACD,MAAO,CACLC,aAAa,CAAE,CACbC,OAAO,CAAEnB,MAAM,CAACe,cAAc,CAC9BK,OAAO,CAAEpB,MAAM,CAACiB,cAAc,CAC9BI,KAAK,CAAErB,MAAM,CAACsB,YAAY,CAC1BC,MAAM,CAAEvB,MAAM,CAACwB,aACjB,CAAC,CACDC,UAAU,CAAE,CACVN,OAAO,CAAElB,aAAa,CACpBC,KAAK,CACLC,UAAU,CAACH,MAAM,CAACc,aAAa,CAAEV,MAAM,CACzC,CAAC,CACDgB,OAAO,CAAEnB,aAAa,CACpBC,KAAK,CACLG,YAAY,CACVF,UAAU,CACRQ,IAAI,CAACe,GAAG,CAAC1B,MAAM,CAACgB,aAAa,CAAEhB,MAAM,CAACiB,cAAc,CAAC,CAAGP,CAAC,CACzD,CACEJ,QAAQ,CAARA,QAAQ,CACRqB,MAAM,CAAEpB,MAAM,CAACqB,GAAG,CAACrB,MAAM,CAACsB,GAAG,CAC/B,CACF,CAAC,CACD1B,UAAU,CAACH,MAAM,CAACgB,aAAa,CAAE,CAC/B,GAAGZ,MAAM,CACTE,QAAQ,CAARA,QAAQ,CACRqB,MAAM,CAAEpB,MAAM,CAACuB,MACjB,CAAC,CACH,CACF,CAAC,CACDT,KAAK,CAAEpB,aAAa,CAACC,KAAK,CAAEC,UAAU,CAACH,MAAM,CAAC+B,WAAW,CAAE3B,MAAM,CAAC,CAAC,CACnEmB,MAAM,CAAEtB,aAAa,CAACC,KAAK,CAAEC,UAAU,CAACH,MAAM,CAACgC,YAAY,CAAE5B,MAAM,CAAC,CACtE,CAAC,CACDI,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var JumpingTransition = exports.JumpingTransition = function(_BaseAnimationBuilder) {
    (0, _inherits2.default)(JumpingTransition, _BaseAnimationBuilder);
    var _super = _createSuper(JumpingTransition);
    function JumpingTransition() {
        var _this;
        (0, _classCallCheck2.default)(this, JumpingTransition);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.build = function() {
            var _this$durationV;
            var delayFunction = _this.getDelayFunction();
            var callback = _this.callbackV;
            var delay = _this.getDelay();
            var duration = ((_this$durationV = _this.durationV) != null ? _this$durationV : 300) / 2;
            var config = {
                duration: duration * 2
            };
            return function() {
                var _e = [
                    new global.Error(),
                    -9,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    var d = Math.max(Math.abs(values.targetOriginX - values.currentOriginX), Math.abs(values.targetOriginY - values.currentOriginY));
                    return {
                        initialValues: {
                            originX: values.currentOriginX,
                            originY: values.currentOriginY,
                            width: values.currentWidth,
                            height: values.currentHeight
                        },
                        animations: {
                            originX: delayFunction(delay, (0, _animation.withTiming)(values.targetOriginX, config)),
                            originY: delayFunction(delay, (0, _animation.withSequence)((0, _animation.withTiming)(Math.min(values.targetOriginY, values.currentOriginY) - d, {
                                duration: duration,
                                easing: _Easing.Easing.out(_Easing.Easing.exp)
                            }), (0, _animation.withTiming)(values.targetOriginY, Object.assign({}, config, {
                                duration: duration,
                                easing: _Easing.Easing.bounce
                            })))),
                            width: delayFunction(delay, (0, _animation.withTiming)(values.targetWidth, config)),
                            height: delayFunction(delay, (0, _animation.withTiming)(values.targetHeight, config))
                        },
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    withTiming: _animation.withTiming,
                    config: config,
                    withSequence: _animation.withSequence,
                    duration: duration,
                    Easing: _Easing.Easing,
                    callback: callback
                };
                anonymous.__initData = _worklet_10364741825758_init_data;
                anonymous.__workletHash = 10364741825758;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this;
    }
    (0, _createClass2.default)(JumpingTransition, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new JumpingTransition();
            }
        }
    ]);
    return JumpingTransition;
}(_animationBuilder.BaseAnimationBuilder);
